import dayjs from 'dayjs';

/**
 * @description 派件员选中数据筛选字符串切割
 * @param  {any[]} data
 * @returns {any[]}
 */
export const filterAndFormatData = (data) => {
  return data.map((item) => {
    const fields = item.split(/:/);
    return {
      source: fields[0],
      dispatcherName: fields[1],
      dispatcherId: fields[2]
    };
  });
};

/**
 * 获取周期
 * 规则:
 *   1. 需要*个日期，不管当前日期
 *   2. 如果当月超过（含） option.generationCycle1Date （例如16号），当月只有第一个周期
 *   3. 如果当月超过（含） option.generationCycle2Date （例如1号），生成上个月周期2
 * @param {number} len 需要的周期数量
 * @param {import('./types').IGenerateOption} option 配置
 * @returns {TGReturn[]}
 */
export const generatePeriods = (len, option) => {
  const { oneTitle, twoTitle, generationCycle2Date, generationCycle1Date } = option;

  const dateArr = getDateList(len, oneTitle, twoTitle);
  const day = dayjs().date(); // 当前几号

  // 不超过则，不生成上个月周期2
  if (day < generationCycle2Date) {
    dateArr.pop(); // 剔除上个月的周期2
    return setDataArr(dateArr, len);
  }

  // 如果超过则生成本月周期1
  if (day >= generationCycle1Date) {
    const str = dayjs().format('YYYY-MM') + ` ${oneTitle}1`;

    /** @type {TGReturn} */
    const obj = {
      years: dayjs().format('YYYY-MM'),
      period: 1,
      label: str
    };
    dateArr.push(obj);
    return setDataArr(dateArr, len);
  }

  return setDataArr(dateArr, len);
};

/**
 * 获取周期，如果超过指定周期数量，则删除多余的周期
 * @param {TGReturn[]} arr 周期
 * @param {number} len 指定周期数量
 * @returns {TGReturn[]}
 */
const setDataArr = (arr, len) => {
  const newArr = [...arr];
  const l = arr.length;
  if (l > len) {
    newArr.splice(0, l - len);
  }
  return newArr;
};

/**
 * 获取周期 生成一个不含当月的周期，例如当前是8月，则会生成
 * @param {number} len 周期长度
 * @param {string} oneTitle 第一个周期的标题
 * @param {string} twoTitle 第二个周期的标题
 * @returns {TGReturn[]}
 */
const getDateList = (len, oneTitle, twoTitle) => {
  const minLen = Math.max(len, 2); // 最小生成2个周期
  const val = Math.ceil(minLen / 2) + 2;

  /** @type {TGReturn[]} */
  const dateArr = [];

  // 不生成本月的周期
  for (let i = 1; i < val; i++) {
    const le = dayjs().subtract(i, 'month').format('YYYY-MM');

    /** @type {TGReturn[]} */
    const obj = [{
      years: `${le}`,
      period: 1, // 周期
      label: `${le} ${oneTitle}1`
    }, {
      years: `${le}`,
      period: 2,
      label: `${le} ${twoTitle}2`
    }];
    dateArr.unshift(...obj);
  }

  return dateArr;
};

